<template>

    <div class="container-fluid">
        <div class="row my-2">
            <div class="col-md-12">
                <h6 class="font-weight-bold">Quote Id: {{quoteNumber}}</h6>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "QuoteNumber",
    props: {
        //Number reference to the current step
        quoteNumber: {
            type: [Number, String],
            required: true,
        }
    },
    data() {
        return {};
    }
};
</script>